// @ts-nocheck
import markdownIt from 'markdown-it';
import markdownItAnchor from 'markdown-it-anchor';
import { html5Media } from 'markdown-it-html5-media';
import mk from '@traptitech/markdown-it-katex';
import markdownItInline from 'markdown-it-for-inline';
import { markdownItInlineFunction, markdownHighlightFunction } from './markdown';

const md = markdownIt({
  breaks: true,
  typographer: true,
  linkify: true,
  html: false, // disable HTML tags in source
  highlight: markdownHighlightFunction,
});

// copy pasted from markdown.ts, no easy way to reuse the logic
md.use(markdownItAnchor, {});
md.use(mk, { blockClass: 'math-block', errorColor: ' #cc0000' });
md.use(markdownItInline, 'url_new_win', 'link_open', markdownItInlineFunction);
md.use(html5Media);

export default md;
